import axios from "axios";
import { ILoggingAPIBody, ILoggingAPIsuccessResposnse } from "../types/LoggingTypes";
import { ActionDimensions } from "../dimensions/ActionDimensions";

export const LoggingAPICall = async (
    body: ILoggingAPIBody
): Promise<ILoggingAPIsuccessResposnse> => {
    
    return axios.post(ActionDimensions.getInstance().url , body , {
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': ActionDimensions.getInstance().token
        }
    })
};
